const CRAWLER_USER_AGENT_PATTERN =
  /adsbot-google|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|applebot|facebookexternalhit|twitterbot|linkedinbot|pinterest|slackbot|discordbot|telegrambot|crawler|spider|bot/i;

export const isChunkLoadError = (error) => {
  const message = String(error?.message || error || "").toLowerCase();

  return (
    message.includes("loading chunk") ||
    message.includes("loading css chunk") ||
    message.includes("unable to preload css") ||
    message.includes("chunkloaderror") ||
    message.includes("failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("importing a module script failed")
  );
};

export const isCrawlerUserAgent = (userAgent) =>
  CRAWLER_USER_AGENT_PATTERN.test(String(userAgent || ""));

export const shouldSuppressChunkLoadSlackLog = (error, userAgent) =>
  isChunkLoadError(error) && isCrawlerUserAgent(userAgent);
